// Static data for the Why Choose Us component
import { FiCompass, FiEdit3, FiStar, FiHeadphones, FiGlobe, FiShield, FiMap } from 'react-icons/fi';

export const WHY_CONTENT = {
  eyebrow: 'Why Choose Us',
  heading: 'Designed for Dependability',
  subheading: 'Every journey backed by ground teams who know the roads, the timing, and the people.',
};

export const WHY_FEATURES = [
  {
    id: 'local-expertise',
    icon: FiCompass,
    title: 'Local Expertise',
    description: 'Ground teams in every region who know the roads, the timing, and the people.',
  },
  {
    id: 'personalized',
    icon: FiEdit3,
    title: 'Personalized Itineraries',
    description: 'No templated routes — every journey is built around the traveller in front of us.',
  },
  {
    id: 'luxury',
    icon: FiStar,
    title: 'Luxury Experiences',
    description: 'Vetted five-star stays and private access most operators cannot arrange.',
  },
  {
    id: 'support',
    icon: FiHeadphones,
    title: 'Customer Support',
    description: 'A dedicated line, day or night, for every group on the ground.',
  },
  {
    id: 'partners',
    icon: FiGlobe,
    title: 'Trusted Global Partners',
    description: 'Working relationships with 500+ agencies across 30+ source markets.',
  },
  {
    id: 'value',
    icon: FiShield,
    title: 'Best Value Guarantee',
    description: 'Transparent net rates with no hidden mark-ups at any stage of the trip.',
  },
  {
    id: 'seamless',
    icon: FiMap,
    title: 'Seamless Travel Flow',
    description: 'End-to-end coordination of flights, transfers, and activities for a friction-free journey.',
  },
];
